import "react";
import { Phone } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
import { Field, useFormikContext } from "formik";
//#region src/components/FormikFields/FormikPhone.tsx
var validatePhone = (phone, required) => {
	if (required || !required && !!phone && phone !== "(") {
		let errorMessage;
		if (!/^(\([0-9]{3}\))\s([0-9]{3})-([0-9]{4})$/i.test(phone)) errorMessage = "Invalid phone format. \"(555) 444-8888\"";
		return errorMessage;
	}
};
var FormikPhone = (props) => {
	const form = useFormikContext();
	return /* @__PURE__ */ jsx(Field, {
		name: props.name,
		validate: (value) => validatePhone(value, props.required),
		children: ({ field, meta }) => /* @__PURE__ */ jsx(Phone, {
			...props,
			error: (meta.touched || !!form.submitCount) && meta.error,
			valid: (meta.touched || !!form.submitCount) && meta.value && !meta.error,
			...field,
			onBlur: (e) => {
				if (props.onBlur) props.onBlur(e);
				field.onBlur(e);
			},
			onChange: (e) => {
				if (props.onChange) props.onChange(e);
				field.onChange(e);
			}
		})
	});
};
//#endregion
export { FormikPhone, validatePhone };

//# sourceMappingURL=FormikPhone.js.map